(function() { window.GUID_8e44ac2c_29ac_4a84_8908_992dd38852fe = { getGuid: function() { return "8e44ac2c-29ac-4a84-8908-992dd38852fe"; } }; })();
var CompuSport;
(function (CompuSport) {
    var Controls;
    (function (Controls) {
        function ShowUserValidatorPopup(currentForm, callback) {
            var me = this;
            var popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: 'UserValidatorPopup',
                Url: CSParameters.BaseUrl + 'Account/ShowUserValidator/',
                Async: false,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            popup.OnPosted = function (result) {
                currentForm.append('<input type="hidden" value="' + result.token + '" name="UserValidatorToken" />');
                callback();
            };
        }
        Controls.ShowUserValidatorPopup = ShowUserValidatorPopup;
    })(Controls = CompuSport.Controls || (CompuSport.Controls = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=UserValidator.js.map
